import axios from "axios";

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.warn("Unauthorized or forbidden, redirecting to /login...");
      window.localStorage.clear()
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
